/*
 * Section: FAQ Accordion — Interactive toggling script
 */

function initFAQSection(section) {
  var items = section.querySelectorAll('.tc-faq-item');
  if (!items || items.length === 0) return;

  items.forEach(function(item) {
    var trigger = item.querySelector('.tc-faq-trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');

      // Close all other items (Accordion mode)
      items.forEach(function(otherItem) {
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          var otherTrigger = otherItem.querySelector('.tc-faq-trigger');
          if (otherTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Toggle current item
      if (isOpen) {
        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

// Initialize all FAQ sections on page load
function initAllFAQs() {
  document.querySelectorAll('.tc-faq-section').forEach(function(section) {
    initFAQSection(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllFAQs);
} else {
  initAllFAQs();
}

// Shopify Theme Customizer reload support
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.contains('tc-faq-section') || event.target.querySelector('.tc-faq-section')) {
    var sectionEl = event.target.classList.contains('tc-faq-section') ? event.target : event.target.querySelector('.tc-faq-section');
    initFAQSection(sectionEl);
  }
});
